import React, { Component, useState, useEffect } from "react";
import cookie from "react-cookies";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "@windmill/react-ui";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { DeleteReduxDataCti } from "src/api/Actions/ServiceCTI/DeleteReduxDataCti";
import Swal from "sweetalert2";
import {
  DeleteReduxDataTicketField,
  GetCtiTicketField,
  SaveTicketField,
} from "../../api/Actions/ServiceCTI";
import FreshdeskFields from "../../components/TicketFields/FreshdeskFields";
import ZendeskFields from "../../components/TicketFields/ZendeskFields";
import FreshsalesFields from "../../components/TicketFields/FreshsalesFields";
// import { CreateTicketField } from "src/api/Actions/ServiceCTI/CreateTicketField";

const CtiModal = () => {
  const dispatch = useDispatch();
  let [NestedChild, setNestedChild] = useState({});
  let [SelectedField, setSelectedField] = useState({});

  const [SelectedMonth, setSelectedMonth] = useState();
  const [OpenDatepicker, setOpenDatepicker] = useState(false);
  let [DataChoices, setDataChoices] = useState({});

  // const getOrganization = useSelector(
  //   (state) => state.Organization.getAllOrganization
  // );

  const GetTicket = useSelector(
    (state) => state.CtiCredential.GetCtiTicketField
  );
  const errorGetTicket = useSelector(
    (state) => state.CtiCredential.errorGetCtiTicketField
  );

  // const CreateTicket = useSelector(
  //   (state) => state.CreateCrmCredential.CreateTicketField
  // );

  const ctiType = useSelector((state) => state.ReduxState.ctiType);

  const isModalOpen = useSelector((state) => state.ReduxState.TicketFieldModal);

  const LoadingTicketField = useSelector(
    (state) => state.ReduxState.LoadingTicketField
  );

  // get ticket field data
  const modalHandler = () => {
    dispatch({ type: "set", TicketFieldModal: !isModalOpen });
    // if (getOrganization.count > 0) {
    const param = {
      orgUuid: localStorage.getItem("orgUuid"),
    };
    dispatch(GetCtiTicketField(ctiType, param));
    // }
  };

  //handle save update field
  const handleSubmit = () => {
    const org = localStorage.getItem("orgUuid");
    const dataReq = {
      orgUuid: org,
      custom_field: [],
    };
    // console.log(SelectedField, "selected value");

    for (const [key, value] of Object.entries(SelectedField)) {
      if (key !== "undefined") {
        if (value !== "null") {
          let type = "";
          if (typeof value["value"] === "number") {
            type = "number";
            // console.log(value["value"], "dia number");
          } else {
            type = `${typeof value["value"]}`;
          }
          let fieldData = {
            field: `${key}`,
            value: `${value["value"]}`,
            type_value: type,
            type: 2,
            status: 1,
          };
          dataReq.custom_field.push(fieldData);
        }
      }
    }
    // console.log(dataReq, "DATA DATAREQ");
    dispatch(SaveTicketField(ctiType, dataReq));
  };

  //handle save update field
  const handleNested = (fieldName, selected, type, parent) => {
    switch (type) {
      case "dropdown":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
        }));
        break;

      case "nested_1":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
          [NestedChild[fieldName][0]]: { value: null, label: "--" },
          [NestedChild[fieldName][1]]: { value: null, label: "--" },
        }));
        break;

      case "nested_2":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
          [NestedChild[parent][1]]: { value: null, label: "--" },
        }));
        break;

      case "nested_3":
        // console.log(fieldName, selected, "nesterd terakhir");
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: selected,
        }));

        break;

      case "textarea":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: selected.target.value, label: "--" },
        }));

        break;

      case "checkbox":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: selected.target.checked, label: "--" },
        }));

        break;

      case "number":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: {
            value: Math.round(selected.target.value),
            label: "--",
          },
        }));

        break;

      case "decimal":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: Number(selected.target.value), label: "--" },
        }));

        break;

      case "date":
        setOpenDatepicker(!OpenDatepicker);
        const datetoconvert = selected;
        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const StartReportPeriod = new Date(selected - tzoffset)
          .toISOString()
          .split("T")[0];
        const EndReportPeriod = new Date(SelectedMonth);
        setSelectedMonth(selected);
        SelectedField[fieldName].value = StartReportPeriod;
        break;

      case "text":
        setSelectedField((prevState) => ({
          ...prevState,
          [fieldName]: { value: selected.target.value, label: "--" },
        }));
        break;

      default:
        break;
    }
  };

  //set remove integration button on/off
  useEffect(() => {
    if (GetTicket) {
      // console.log(GetTicket, " ini data getticket gays");
      if (GetTicket.data.length > 0) {
        const optionsData = {};
        const nestedChildData = {};
        const fieldList = {};
        GetTicket.data[0].rows.ticket_fields.forEach((element) => {
          fieldList[element.name] = { value: null, label: "--" };
          let array = [{ value: null, label: "--" }];
          let arrayNestedChild = [];
          // jika element memiliki choices
          if (element.choices || element.system_field_options) {
            // jika tipe choices dari data adalah array
            if (element.choices && Array.isArray(element.choices)) {
              element.choices.forEach((a) => {
                let object = { value: a, label: a };
                array.push(object);
              });

              optionsData[element.name] = array;
            } else if (
              element.system_field_options &&
              Array.isArray(element.system_field_options)
            ) {
              element.system_field_options.forEach((a) => {
                let object = { value: a.value, label: a.name };
                array.push(object);
              });

              optionsData[element.name] = array;
            } else {
              // jika tipe choices dari data adalah object
              if (element.type === "nested_field") {
                //untuk nampung data selected
                for (
                  let index = 0;
                  element.nested_ticket_fields.length > index;
                  index++
                ) {
                  arrayNestedChild.push(
                    element.nested_ticket_fields[index].name
                  );

                  fieldList[arrayNestedChild[index]] = {
                    value: null,
                    label: "--",
                  };
                }
              }

              for (const [key, value] of Object.entries(element.choices)) {
                if (element.type === "default_status") {
                  // console.log("MASUK KE DEFAULT STATUS");
                  let object = { value: Number(key), label: value[0] };

                  array.push(object);
                } else if (element.type === "nested_field") {
                  let subObject = value; //ini yang harus di looping

                  const ChildName = `${arrayNestedChild[0]}_${key.replace(
                    " ",
                    "_"
                  )}`;

                  let array2 = [{ value: null, label: "--" }];
                  let object = { value: key, label: key };
                  array.push(object);

                  for (const [key1, value1] of Object.entries(subObject)) {
                    const GrandChildName = `${
                      arrayNestedChild[1]
                    }_${key1.replace(" ", "_")}`;

                    let array3 = [{ value: null, label: "--" }];
                    let object2 = { value: key1, label: key1 };
                    array2.push(object2);

                    for (const [key2, value2] of Object.entries(value1)) {
                      let object3 = { value: value2, label: value2 };
                      array3.push(object3);
                    }
                    optionsData[GrandChildName] = array3;
                  }
                  optionsData[ChildName] = array2;
                } else {
                  // console.log("MASUK KE SINI yang status");
                  let object = { value: value, label: key };
                  // console.log(object, "INI OBJECTNYA");
                  array.push(object);
                }

                //console.log(optionsData, 'options data');
                nestedChildData[element.name] = arrayNestedChild;
                optionsData[element.name] = array;
              }
            }
          } else if (element.system_field_options) {
          }
        });
        //console.log(optionsData, 'data optionsnnya coy')
        setSelectedField(fieldList);
        setNestedChild(nestedChildData);
        setDataChoices(optionsData);
      }
    }

    dispatch({ type: "set", LoadingTicketField: false });
  }, [GetTicket]);

  useEffect(() => {
    dispatch({ type: "set", LoadingTicketField: false });
    dispatch(DeleteReduxDataTicketField());
  }, [errorGetTicket]);

  return (
    <>
      <Modal
        className="fixed bg-white w-1/2 h-3/4 p-10 rounded-xl overflow-y-auto"
        isOpen={isModalOpen}
        onClose={modalHandler}
      >
        <ModalHeader>
          <div className="border-b border-gray-200">
            <p className="font-bold text-2xl text-center capitalize">
              {ctiType} Ticket Field
            </p>
          </div>
        </ModalHeader>
        <ModalBody>
          {LoadingTicketField ? (
            <p className="mt-10 w-full text-center font-semibold poppins-500">
              loading ticket field data...
            </p>
          ) : (
            <div className="">
              {ctiType === "zendesk" ? (
                <ZendeskFields />
              ) : ctiType === "freshdesk" ? (
                <FreshdeskFields />
              ) : ctiType === "freshsales" ? (
                <FreshsalesFields />
              ) : (
                ""
              )}
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default CtiModal;
